document.addEventListener('DOMContentLoaded', function () {
  // Global Swiper instance
  let swiperInstance = null;

  // Custom SVG icons for navigation buttons (optional)
  const nextButtonSVG = `
    <svg class="icon icon-slider-next icon--medium" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M7.5 3.74121L13.75 9.99121L7.5 16.2412" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
    </svg>
  `;
  const prevButtonSVG = `
    <svg class="icon icon-slider-prev icon--medium" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M12.75 16.2505L6.5 10.0005L12.75 3.75049" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
    </svg>
  `;

  // Initialize Swiper Slider 
  function initializeSwiper() {
    console.log("Swiper Slider inititialized")
    const swiperContainer = document.querySelector('.free-products-inner.custom-swiper');
    const isInitialized=jQuery('.free-products-inner.custom-swiper').hasClass("swiper-initialized")
    const productContainer = document.querySelector('.free-products-inner');
    const countFreeSample = parseInt(productContainer?.className.match(/count_free_sample-(\d+)/)?.[1] || 0);

    if (swiperContainer && countFreeSample >= 3 && !isInitialized) {
      console.log("Inside logic")
      // Initialize Swiper slider
      // if (swiperInstance) {
      //   swiperInstance.destroy(false, false);
      // }
     let carousel= new FoxTheme.Carousel(swiperContainer, {
      slidesPerView: 3,
      spaceBetween: 10,
      loop: true,
      pagination: {
         el: swiperContainer.querySelector('.swiper-pagination'),
         clickable: true,
       },
      navigation: {
       nextEl: swiperContainer.querySelector('.swiper-button-next'),
      prevEl: swiperContainer.querySelector('.swiper-button-prev'),
      },
        breakpoints: {
         320: { slidesPerView: 1, spaceBetween: 10 },
         640: { slidesPerView: 2, spaceBetween: 15 },
         1024: { slidesPerView: 3, spaceBetween: 20 },
         }
    });
     carousel && carousel.init();
 console.log("carousel",carousel);


    } else if (productContainer && countFreeSample <3) {
      productContainer.classList.remove('custom-swiper');
      productContainer.classList.add('grid-pro-jtpl');
    }
  }
jQuery(window).on('resize load', function() {
  initializeSwiper();
});
jQuery(document).on('cart:refresh', function() {
  if (jQuery("[id^=CartDrawerBody] cart-items ul li").length) {
    setTimeout(() => {
      console.log("cart refresh==")
      initializeSwiper();
      
    }, 1500);
    setTimeout(() => {
      updateButtonVisibility();
    }, 1800);
    
  }
});
  // Fetch current cart contents
  async function getCart() {
    try {
      const response = await fetch('/cart.js', { method: 'GET', headers: { 'Content-Type': 'application/json' } });
      if (!response.ok) throw new Error(`Failed to fetch cart: ${response.status}`);
      const cart = await response.json();
      return cart;
    } catch (error) {
      console.error('Error fetching cart:', error);
      return { items: [] };
    }
  }
  //
 

  // Update buttons (Add/Remove) visibility based on cart contents
  async function updateButtonVisibility() {
    console.log("updateButtonVisibility===");
    const cart = await getCart();
    console.log("cart..",cart)
    const cartVariantIds = cart.items.map(item => item.variant_id);
    jQuery(".add-free-sample-btn .free-sample-atc-jtpl").removeAttr("disabled")

    document.querySelectorAll('.add-free-sample-btn').forEach(container => {
      const addButton = container.querySelector('.free-sample-atc-jtpl');
      const removeButton = container.querySelector('.free-sample-remove-jtpl');
      if (!addButton || !removeButton) return;

      const variantId = parseInt(addButton.getAttribute('product-atc-id'), 10);

      if (cartVariantIds.includes(variantId)) {
        jQuery(".add-free-sample-btn .free-sample-atc-jtpl").attr("disabled",true)
        addButton.style.display = 'none';
        removeButton.style.display = 'block';
      } else {
        addButton.style.display = 'block';
        removeButton.style.display = 'none';
      }
    });

    // initializeSwiper();

    // Trigger Shopify/Sleek theme cart update event if needed
    // document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
  }

  // Add item to cart
  async function addToCart(variantId) {
    jQuery(".free-sample-atc-jtpl").attr("disabled","true")
    const addBtn = document.querySelector(`.free-sample-atc-jtpl[product-atc-id="${variantId}"]`);
    if (addBtn) addBtn.disabled = true;

    const maxFreeSamples = parseInt(document.querySelector('.free-sample-gift-container')?.getAttribute('max-free-sample')) || Infinity;
    const cart = await getCart();
    const freeSampleCount = cart.items.filter(item => item.properties && item.properties._free_sample_product).length;

    if (freeSampleCount >= maxFreeSamples) {
      alert('You have reached the maximum number of free samples allowed.');
      if (addBtn) addBtn.disabled = false;
      return;
    }

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [{ id: variantId, quantity: 1, properties: { _free_sample_product: "free_sample_product" } }],
        }),
      });
      if (!response.ok) throw new Error(`Failed to add to cart: ${response.status}`);

      // await updateButtonVisibility();
      // document.dispatchEvent(new CustomEvent('cart:change', { detail: { variantId } }));
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      // initializeSwiper()
      console.log("Initialized after adding==")
     if (!jQuery(".cart-drawer").length) {
  window.location.reload();
}
    } catch (error) {
      console.error('Error adding to cart:', error);
      alert('Failed to add product to cart. Please try again.');
    } finally {
      if (addBtn) addBtn.disabled = false;
    }
  }

  // Remove item from cart
async function removeFromCart(variantId) {
  console.log('Trying to remove variant:', variantId);
  const removeBtn = document.querySelector(`.free-sample-remove-jtpl[product-rmv-id="${variantId}"]`);
  if (removeBtn) removeBtn.disabled = true;

  try {
    const response = await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates: { [variantId]: 0 } }),
    });
    if (!response.ok) throw new Error(`Failed to remove from cart: ${response.status}`);

    // const updatedCart = await response.json();
    // console.log('Remove success. Updated cart:', updatedCart);

     document.dispatchEvent(new CustomEvent('cart:refresh'));
      // initializeSwiper()
      var url = window.location.href;
    // console.log(url.indexOf("/cart"));
    if(url.indexOf("/cart") > -1){
      location.reload(true);
      return false; 

     }
  } catch (error) {
    console.error('Error removing from cart:', error);
    // alert('Failed to remove product from cart. Please try again.');
  } finally {
    if (removeBtn) removeBtn.disabled = false;
  }
}


  // Modal open/close helpers
  function openModal(modalId) {
    const modal = document.getElementById(modalId);
    if (modal) {
      modal.style.display = 'block';
      modal.style.opacity = '0';
      setTimeout(() => {
        modal.style.opacity = '1';
        modal.style.transition = 'opacity 0.3s ease';
      }, 10);
      document.body.style.overflow = 'hidden';
      document.dispatchEvent(new CustomEvent('modal:open', { detail: { modalId } }));
    }
  }

  function closeModal(modalId) {
    const modal = document.getElementById(modalId);
    if (modal) {
      modal.style.opacity = '0';
      setTimeout(() => {
        modal.style.display = 'none';
        document.body.style.overflow = 'auto';
      }, 300);
      document.dispatchEvent(new CustomEvent('modal:close', { detail: { modalId } }));
    }
  }
  
  jQuery('body').on('click', '.free-sample-remove-jtpl', function(event) {
    event.preventDefault();
    const variantId = parseInt(jQuery(this).attr('product-rmv-id'), 10);
    if (variantId) {
      removeFromCart(variantId);
      return;
    }
  });
  // Setup event delegation
  function setupEventListeners() {
    document.body.addEventListener('click', function (event) {
      // Add to cart button click
      const addBtn = event.target.closest('.free-sample-atc-jtpl');
      if (addBtn) {
        event.preventDefault();
        const variantId = parseInt(addBtn.getAttribute('product-atc-id'), 10);
        if (variantId) addToCart(variantId);
        console.log("variantId---",variantId);
        
        document.querySelectorAll('.add-free-sample-btn').forEach(container => {
          const addButton = container.querySelector('.free-sample-atc-jtpl');
          const removeButton = container.querySelector('.free-sample-remove-jtpl');
          if (!addButton || !removeButton) return;

          const variantId = parseInt(addButton.getAttribute('product-atc-id'), 10);

          if (cartVariantIds.includes(variantId)) {
            jQuery(".add-free-sample-btn .free-sample-atc-jtpl").attr("disabled",true)
            addButton.style.display = 'none';
            removeButton.style.display = 'block';
          } else {
            addButton.style.display = 'block';
            removeButton.style.display = 'none';
          }
        });

        return;
      }

      // Remove from cart button click

      // Modal open buttons
      if (event.target.matches('.modal-opener-free-sample')) {
        event.preventDefault();
        const productId = event.target.getAttribute('data-product-id');
        if (productId) openModal(`modal-${productId}`);
        return;
      }

      // Modal close buttons
      if (event.target.matches('.modal_close-jtpl')) {
        event.preventDefault();
        const modalId = event.target.getAttribute('data-modal-id');
        if (modalId) closeModal(modalId);
        return;
      }
    });

    // jQuery handlers (if jQuery is present)
    if (window.jQuery) {
    

      jQuery(document).on('click', '.modal_close-jtpl', function (e) {
        e.preventDefault();
        jQuery(".data-modal-show").hide();
        jQuery("body").removeClass("quick-large-open");
      });

      jQuery(document).on('click', '.checkout__cart', function () {
        jQuery(".data-modal-show").hide();
        jQuery("body").removeClass("quick-large-open");
      });
    }
  }

  // Initialize everything
  setupEventListeners();
  updateButtonVisibility();

  // Reinitialize Swiper on theme events
  // document.addEventListener('shopify:section:load', initializeSwiper);
  // document.addEventListener('shopify:section:unload', () => {
  //   if (swiperInstance) {
  //     swiperInstance.destroy(true, true);
  //     swiperInstance = null;
  //   }
  // });

  document.addEventListener('cart:updated', ()=>{
    console.log("Cart updated===")
    updateButtonVisibility()
    initializeSwiper()
    // ClearCartDrawerSample()
  });
  //  FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, (data) => {
  //     console.log('Cart was updated:', data);
  //    console.log("Cart updated===")
  //   updateButtonVisibility()
  //     // You can call your custom function here
  //   });
  // document.addEventListener('cart:updated', ClearCartDrawerSample);
  
  
  jQuery(document).on('click','.free-sample-main-section .main-headingcontent-jtpl',function(e){ 
    e.preventDefault();
      jQuery('.free-sample-products').toggle();
      jQuery('.main-headingcontent-jtpl').toggleClass('close');
    });
    
    
    jQuery(document).on('click','button.modal-opener-free-sample',function(e){ 
      e.preventDefault();
      jQuery(".data-modal-show").html('');
         jQuery("body").addClass("quick-large-open");
         var modalData = jQuery(this).parents(".total-modalninfo").find(".data-to-upload-jtpl").html();
         console.log('show))');
         jQuery(".data-modal-show").html(modalData);
         jQuery(".data-modal-show").show();
        });
   
        jQuery(document).on('click','.modal_close-jtpl',function(e){ 
          e.preventDefault();
          jQuery(".data-modal-show").hide();
          jQuery("body").removeClass("quick-large-open");
        });
        
        jQuery(document).on('click','.checkout__cart',function(){ 
          jQuery(".data-modal-show").hide();
          jQuery("body").removeClass("quick-large-open");
     });
     
    });
     
     